import { useEffect } from "react"



const InputTextArea = ({id,label,onChange,value,className,bg="bg-white",infos,disabled}) => {


    useEffect(()=>{
        var obj = document.getElementById(id ?? "input_"+label)
        if(obj.value!==(value??""))obj.value=(value??"")
       
       },[value,id,label])
return (
    <>
    <div className={"relative bg-inherit " +className } >
    <textarea readOnly={disabled} id={id ?? "input_"+label} onChange={(e)=>onChange(e.target.value)}  rows={Math.max(1, value?.split("\n").length+1 ?? 0 )  } value={value}  className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-inherit rounded-lg border border-gray-400 appearance-none   focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " />
    <label htmlFor={ "input_"+label } className={"absolute text-sm text-gray-500  duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 " +bg }>{label}</label>
    {infos  &&  <div className="italic w-full text-xs p-1 text-left  whitespace-pre-line">{infos}</div>}
    </div>
    
</> 
)
}
export default InputTextArea